import * as Styled from './styled';
import { Props } from './types';

function FieldRow({ isLastRow, children }: Props) {
  return (
    <Styled.FieldRow $isLastRow={isLastRow} role="row">
      {children}
    </Styled.FieldRow>
  );
}

export default FieldRow;
